<template>
    <div class="invesHeader">

        <div class="header white-header shadow invesHeader-z">
            <div class="box1200 clearfix">
                <div class="logo fl headerlogo"><router-link to="/" title="回到首页"><img src="../assets/qw/inmet_logo.png"></router-link></div>
                <div class="login-btn fr"><a v-if="!this.$store.state.code  && !this.$store.state.openid" class="goto el-icon-user-solid" @click="login" > 登录/注册</a></div>
                <div class="login-btn fr"><a v-if="this.$store.state.code  && !this.$store.state.openid" class="goto" @click="login">登录/注册</a></div>


                <div class="logged fr" v-if="this.$store.state.user_type === 0 && this.$store.state.is_auth === 1 && this.$store.state.rank === 0">
                    <router-link to="/enterprise/manage" class="user"><span class="userImg"><img :src="enterprise_logo"></span></router-link>
                    <el-dropdown placement="bottom">
                        <router-link class="name" to="/enterprise/manage"><i class="el-icon-arrow-down el-icon--right"></i></router-link>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item><router-link to="/enterprise/info" class="dropItem">{{ep_name}}</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/enterprise/info" class="dropItem">企业信息</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/enterprise/order" class="dropItem">我的推广</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/enterprise/balance" class="dropItem">我的余额</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/enterprise/account" class="dropItem">运营账号</router-link></el-dropdown-item>
                            <el-dropdown-item divided><span @click="loginOut" class="dropItem">退出</span></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- 邮箱 -->
                    <router-link to="/enterprise/message">
                        <el-badge class="none" v-if="is_new == 0"><i class="el-icon-message"></i></el-badge>
                        <el-badge is-dot class="newDot" v-if="is_new == 1"><i class="el-icon-message"></i></el-badge>
                    </router-link>
                </div>
                <div class="logged fr" v-if="this.$store.state.user_type === 0 && this.$store.state.is_auth === 1 && this.$store.state.rank === 1">
                    <el-dropdown placement="bottom">
                    <router-link class="user" to="/enterprise/manage"><span class="userImg"><img :src="enterprise_logo"></span></router-link>
                     <!-- <router-link class="name" to="/enterprise/manage"><i class="el-icon-arrow-down el-icon--right"></i></router-link> -->
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item  style="border-bottom: 1px #F5F5F5 solid;"><router-link to="/enterprise/manage" class="dropItem">{{ep_name}}</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/enterprise/info" class="dropItem">企业信息</router-link></el-dropdown-item>
                            <el-dropdown-item ><router-link to="/enterprise/order" class="dropItem">我的推广</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/enterprise/balance" class="dropItem">我的余额</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/enterprise/account" class="dropItem">运营账号</router-link></el-dropdown-item>
                            <el-dropdown-item divided><span @click="loginOut" class="dropItem">退出</span></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="logged fr" v-if="this.$store.state.user_type === 1 && this.$store.state.is_auth === 1 && this.$store.state.newbie_task === 0">
                    <span class="user"><img :src="head_img"></span>
                    <span class="name">{{daren_name}}</span>
                    <router-link to="/daren-register/result" class="goto">完成新手任务</router-link>
                    <span class="loginOut" @click="loginOut">退出</span>
                </div>
                <div class="logged fr" v-if="this.$store.state.user_type === 1 && this.$store.state.is_auth === 1 && this.$store.state.newbie_task === 1">
                    <el-dropdown placement="bottom">
                    <router-link class="user" to="/daren/manage"><span class="userImg"><img :src="head_img"></span></router-link>
                        <!-- <router-link class="name" to="/daren/manage"><i class="el-icon-arrow-down el-icon--right"></i></router-link> -->
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item><router-link to="/daren/info" class="dropItem">{{daren_name}}</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/daren/info" class="dropItem">个人信息</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/daren/order" class="dropItem">我的订单</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/daren/agent" class="dropItem" v-if="this.$store.state.is_agent === 1">代客下单</router-link></el-dropdown-item>
                            <el-dropdown-item><router-link to="/daren/balance" class="dropItem">我的余额</router-link></el-dropdown-item>
                            <el-dropdown-item divided><span @click="loginOut" class="dropItem">退出</span></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- 邮箱图标 -->
                </div>

                <div class="tourist fr" v-if="this.$store.state.openid && this.$store.state.user_type === 3 && !this.$store.state.is_auth"><span class="margin-right-10">尊敬的游客，欢迎您来到{{this.$store.state.siteName}}</span><router-link to="/operator" class="goto" style="margin-right:10px;">企业运营登录</router-link><router-link to="/register" class="goto">立即去认证</router-link><span class="loginOut" @click="loginOut">退出</span></div>
                <div class="tourist fr" v-if="this.$store.state.is_auth ===2"><span class="margin-right-10">很抱歉，认证审核不通过，如有疑问请拨打0753-2354999</span><span class="loginOut" @click="loginOut">退出</span></div>
                <div class="tourist fr" v-if="this.$store.state.user_type === 0">
                    <div v-if="this.$store.state.is_auth === 0">
                        <span class="margin-right-10">尊敬的企业，欢迎您来到{{this.$store.state.siteName}}</span><router-link to="/enterprise-register/result" class="goto">查看认证结果</router-link><span class="loginOut" @click="loginOut">退出</span>
                    </div>
                </div>
                <div class="tourist fr" v-if="this.$store.state.user_type === 1">
                    <div v-if="this.$store.state.is_auth === 0 && this.$store.state.auth_type === 0">
                        <span class="margin-right-10">尊敬的达人，欢迎您来到{{this.$store.state.siteName}}</span><router-link to="/daren-register/select" class="goto">培训认证</router-link><span class="loginOut" @click="loginOut">退出</span>
                    </div>
                    <div v-if="this.$store.state.is_auth === 0 && this.$store.state.auth_type === 1">
                        <span class="margin-right-10">尊敬的达人，欢迎您来到{{this.$store.state.siteName}}</span><router-link to="/daren-register/result" class="goto">查看认证结果</router-link><span class="loginOut" @click="loginOut">退出</span>
                    </div>
                </div>

                <div class="nav fr ">
                    <ul>
                        <li class="item"  :class="activeClass == 1 ? 'active':'navitem_hover'"><router-link to="/">首页</router-link></li>
                        <li class="item"  :class="activeClass == 2 ? 'active':'navitem_hover'"><router-link to="/list">任务大厅</router-link></li>
                        <!-- <li class="item"><a href="javascript:void(0)" @click="dialogVisible = true">招商加盟</a></li> -->
                        <li class="item"  :class="activeClass == 3 ? 'active':'navitem_hover'"><router-link to="/investment" >招商加盟</router-link></li>
                        <li class="item"  :class="activeClass == 4 ? 'active':'navitem_hover'"><router-link to="/about" >关于我们</router-link></li>
                        <!-- <li class="item "  v-if="!this.$store.state.code  && !this.$store.state.openid"  @click="login" ><router-link class="el-icon-user-solid"  >登录注册</router-link></li>
                        <li class="item el-icon-user-solid" v-if="this.$store.state.code  && !this.$store.state.openid"  @click="login" ><router-link >登录注册</router-link></li> -->

                <!-- <div class="login-btn fr"><a  class="goto">登录/注册</a></div> -->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    epInfo,
    myDarenInfo,
    addBusiness,
    newsData,
    gethomepc
} from '@/config/api.js'
export default {
    name: 'PublicHeader',
    inject:['goLogin'],
    data () {
        return {
             activeClass:Number,
            ep_name: '',
            enterprise_logo: '',
            daren_name: '',
            head_img: '',
            is_auth: '',
            is_agent: null,
            user_id: null,
            newbie_task: '',
            rank: '',
            auth_type: '',
            dialogVisible: false,
            form: {
                name: '',
                nickname: '',
                telephone: '',
                area: ''
            },
            headerLogo:[],
            rules: {
                name: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ],
                nickname: [
                    { required: true, message: '请输入您的称呼', trigger: 'blur' }
                ],
                telephone: [
                    { required: true, message: '请输入电话号码', trigger: 'blur' }
                ],
                area: [
                    { required: true, message: '请输入意向加盟区域', trigger: 'blur' }
                ],
            },
            is_new: null
        }
    },
    methods: {
        getInfo () {
            if (this.$store.state.user_type === 0) {
                let data = {
                    ep_id:this.$store.state.user_id,
                    user_type: this.$store.state.user_type,
                };
                this.$post(epInfo, data)
                    .then(res => {
                        let data = res.data;
                        this.ep_name = data.name;
                        this.enterprise_logo = data.enterprise_logo;
                        this.is_auth = Number(data.is_auth);
                        this.rank = Number(data.rank);
                        this.$store.commit('changeIsAuth',this.is_auth);
                        this.$store.commit('changeRank',this.rank);
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
            } else if (this.$store.state.user_type === 1) {
                let data = {
                    user_id: this.$store.state.user_id,
                    user_type: this.$store.state.user_type,
                };
                this.$post(myDarenInfo, data)
                    .then(res => {
                        let data = res.data;
                        this.daren_name = data.name;
                        this.head_img = data.head_img;
                        this.is_auth = Number(data.is_auth);
                        this.newbie_task = Number(data.newbie_task);
                        this.auth_type = Number(data.auth_type);
                        this.is_agent = Number(data.is_agent);
                        this.$store.commit('changeAuthType',this.auth_type);
                        this.$store.commit('changeIsAuth',this.is_auth);
                        this.$store.commit('changeNewbieTask',this.newbie_task);
                        this.$store.commit('changeIsAgent',this.is_agent);
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
            }
        },
        getheadLogo(){
            this.$post(gethomepc,{
                key:'pc_home_page'
            }).then(res=>{
                 let data = JSON.parse(res.data);
                this.headerLogo=data.logo;
            })
        },
        getMessage () {
            if (this.$store.state.user_type === 0) {
                let data = {
                    user_type:0,
                    user_id:this.$store.state.user_id,
                };
                this.$post(newsData,data)
                    .then(res => {
                        let data = res.data;
                        this.is_new = data.is_new;
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
            } else if (this.$store.state.user_type === 1) {
                let data = {
                    user_type:1,
                    user_id:this.$store.state.user_id,
                };
                this.$post(newsData,data)
                    .then(res => {
                        let data = res.data;
                        this.is_new = data.is_new;
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
            }

        },
        loginOut () {
            this.$confirm('确定要退出吗？是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$store.commit('changeCode' ,'');
                this.$store.commit('changeAuthToken' ,'');
                this.$store.commit('changeOpenId' ,'');
                this.$store.commit('changeUnionId' ,'');
                this.$store.commit('changeIsAuth' ,NaN);
                this.$store.commit('changeId' ,NaN);
                this.$store.commit('changeUserType' ,3);
                this.$store.commit('changeIsOperater' ,0);
                this.$store.commit('changeIsPass' ,NaN);
                this.$store.commit('changeAuthType' ,NaN);
                this.$store.commit('changeRank' ,NaN);
                this.$store.commit('changeNewbieTask' ,NaN);
                this.$store.commit('changeIsAgent' ,NaN);
                this.$store.commit('changeIsAnswer' ,NaN);
                this.$store.commit('changeIsInfo' ,NaN);
                this.$store.commit('changeWeChatNumber' ,NaN);
                this.$store.commit('changeWeChatFriendNum' ,NaN);
                this.$store.commit('changeSource' ,NaN);
                this.$store.commit('changeLabel' ,NaN);
                this.$store.commit('changeGetTime' ,NaN);
                this.$store.commit('changeIsLogin' ,NaN);
                this.$message({
                    type: 'success',
                    message: '成功退出!'
                });
                setTimeout(() => {
                    this.$router.push('/')
                },1000)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });
            });
        },
        handelJoin (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let data = {
                        name: this.form.name,
                        nickname: this.form.nickname,
                        telephone: this.form.telephone,
                        area: this.form.area,
                    };
                    this.$post(addBusiness,data)
                        .then(() => {
                            setTimeout(() => {
                                this.$message.success('提交成功，我们会有工作人员与您联系，请保持电话畅通');
                            }, 1000);
                        })
                        .catch(() => {
                            setTimeout(() => {
                                this.$message.error('提交失败，请重新提交');
                            }, 100);
                        })
                }
            })
        },
        login () {
            this.goLogin()
        },
        changClass(){
      if(this.$route.path=='/')this.activeClass = 1
        if(this.$route.path=='/investment')this.activeClass=3
          if(this.$route.path=='/list') this.activeClass=2
            if(this.$route.path=='/about') this.activeClass=4
    }
    },
    mounted() {
        this.changClass();
        this.getInfo();
        this.getMessage();
        this.getheadLogo();
    }
}
</script>
<style scoped>
    .navitem_hover:hover{
        /* background: #F9F9F9; */

    }
    .invesHeader .white-header .item a:hover{
            border-bottom:3px solid #ffffff;
    }
    .nav .item {
    margin: 0 !important;
    height: 60px;
    display: inline-block;
    min-width: 104px;
    text-align: center;
    }
    .nav .item a {
    color: #fff;
    font-size: 14px;
    text-align: center;
    display: inline-block;
    line-height: 57px;
    /* border-bottom: 3px solid #fff !important; */
}
    .invesHeader .joinBox .title{text-align:center;line-height:80px;font-size:14px;}
    .invesHeader .joinBox .el-button{width:100%;}
    .invesHeader .new-header{background: #fff;width: 100%;height:70px;position: fixed;top: 0;left: 0; z-index: 99;}
    .invesHeader .new-header .box1200{height: 70px;}
    .invesHeader .new-header .logo{width:200px;}
    .invesHeader .new-header .new-nav{width: calc(100% - 200px);justify-content:flex-end;font-size: 14px;}
    .invesHeader .new-header .new-nav .item{display: block;width:104px;height:70px;line-height: 70px;text-align: center;}
    .invesHeader .new-header .new-nav .item a{display: block;color:#A6A6A6;cursor: pointer;}
    .invesHeader .new-header .new-nav .item a:hover{background: #F9F9F9;}
    .invesHeader .new-header .new-nav .item .active a{color:#fff !important; height:64px;line-height: 64px;display: inline-block;}
    .invesHeader .new-header .logged img{ width: 36px;height: 36px;margin-right:8px;border-radius: 100%;}
    .invesHeader .new-header .logged .line{height: 20px;width: 1px;background: #eee;}
    .invesHeader .new-header .logged span{width: 70px;text-align: right;}
    .invesHeader .active a{border-bottom:3px #ffffff solid  !important; color:#fff !important; }
    .invesHeader .new-nav .login{display: block;width:104px;height:70px;line-height: 70px;text-align: center;}
    .invesHeader .new-header .login a{display: block;color:#A6A6A6;cursor: pointer;}
    .invesHeader .new-nav .login a:hover{background: linear-gradient(#FF6E16, #FFB974);color:#fff;}
    .invesHeader .new-header .new-nav .login i{margin-right:5px;}
    .invesHeader .new-header .logged{height: 70px; width: 90px;
    text-align: center;
    line-height: 92px;
    }


    .invesHeader .white-header .item a{
        color: #fff;
    }
    .invesHeader .white-header .goto {
        border-bottom: 3px rgba(255,255,255,0) solid;
            transition: all 0.1s ease-in;
            color: #ffffff;
            /* width: 105px; */
            height: 60px;
            /* border:none; */
}
    .invesHeader .white-header .goto:hover{
        /* background: linear-gradient(180deg,rgba(255,110,22,1) 0%,rgba(255,185,116,1) 100%); */
            border-bottom:3px solid #ffffff;

    }
.goto {
    cursor: pointer;
    /* padding: 0 15px; */
    height: 60px;
    text-align: center;
    /* border: 1px rgba(255,255,255,.5) solid; */
    color: #fff;
    border-radius: 0px;
    margin-top: 0px;
    display: inline-block;
    line-height: 60px;
    color: #A6A6A6;
}
.nav{
    /* margin-left: 525px; */
}
.invesHeader{
    height: 60px;
}
.invesHeader .headerlogo{
    margin-top: 14px;
}

.invesHeader .white-header{
    background: none;
    box-shadow: none;
}
.login-btn{
    text-align: center;
    width: 104px;
}
</style>
